import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import RefundPolicy from "@/pages/RefundPolicy";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import TrackOrder from "@/pages/TrackOrder";
import LeadCaptureModal from "@/components/LeadCaptureModal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AuthCallback from "@/pages/admin/AuthCallback";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AdminOrders, AdminLeads, AdminMessages, AdminPromos, AdminGeo } from "@/pages/admin/AdminPages";
import { AuthProvider } from "@/lib/auth";
import { CanonicalTag } from "@/components/CanonicalTag";

function App() {
  return (
    <div className="App bg-white text-[#0A0A0A] min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <CanonicalTag />
          <Routes>
            <Route path="/" element={<><Landing /><LeadCaptureModal /></>} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/success" element={<Success />} />
            <Route path="/cancel" element={<Cancel />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/track" element={<TrackOrder />} />
            {/* Admin */}
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/admin/profile" element={<AuthCallback />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin/messages" element={<AdminMessages />} />
            <Route path="/admin/promos" element={<AdminPromos />} />
            <Route path="/admin/geo" element={<AdminGeo />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;